import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { toJS } from 'mobx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { SearchResultBeket } from 'widgets/beket/beket-search-result'

import { useGetSearchParamsBeket } from 'features/libs/get-search-params/getSearchParams'

import findTicketStore from 'entities/beket/models/find-ticket/find-ticket-store'

const SearchResultBeketPageWidget = observer(() => {
  const navigate = useNavigate()

  const dynamicDirection = useGetSearchParamsBeket()

  const formFindTicket = toJS(findTicketStore.formFindTicket)

  useEffect(() => {
    if (dynamicDirection) {
      formFindTicket.directions[0] = dynamicDirection

      findTicketStore.onSelectDirection(dynamicDirection)
    } else {
      navigate(RoutingPaths.beket.base())
    }
  }, [])

  return <SearchResultBeket findFormBeket={formFindTicket} />
})

export default SearchResultBeketPageWidget
